import React from 'react';
import { CheckCircle2, ArrowRight, Lock } from 'lucide-react';

const FreeAuditSection = () => {
  return (
    <section id="free-audit" className="py-24 bg-brand-dark relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row gap-16">
          
          {/* Sol Taraf - Bilgilendirme */}
          <div className="lg:w-1/2">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-8">
              What You'll Get in Your <span className="text-brand-magenta">Free Audit:</span>
            </h2>
            
            <div className="space-y-6">
              {[
                { title: "Hook Analysis", desc: "We'll tell you if your first 3 seconds are compelling enough to stop the scroll." },
                { title: "Pacing Breakdown", desc: "Identify slow moments that cause viewers to drop off." },
                { title: "Retention Score", desc: "Get an estimated retention rate based on our proprietary framework." },
                { title: "3 Quick Wins", desc: "Actionable changes you can implement immediately to boost performance." },
                { title: "CTA Optimization", desc: "How to improve your call-to-action for better conversion." }
              ].map((item, index) => (
                <div key={index} className="flex gap-4 p-6 rounded-2xl border border-white/5 bg-white/5 hover:border-brand-magenta/30 transition-colors">
                  <CheckCircle2 className="text-brand-magenta flex-shrink-0" size={24} />
                  <div>
                    <h3 className="text-white font-bold text-lg mb-1">{item.title}</h3>
                    <p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Sağ Taraf - Form (Bağlanan Kısım) */}
          <div className="lg:w-1/2">
            <div className="bg-brand-darker border border-brand-magenta/30 p-8 md:p-10 rounded-3xl shadow-2xl relative overflow-hidden">
              <div className="relative z-10">
                <h3 className="text-3xl font-bold text-white mb-2 text-center">Claim Your Free Audit</h3>
                <p className="text-gray-400 text-center mb-8">Results delivered within 24 hours</p>

                {/* FORMSPREE BAĞLANTISI BURADA */}
                <form 
                  action="https://formspree.io/f/mzdaazqd" 
                  method="POST"
                  className="space-y-5"
                >
                  <div>
                    <label className="block text-sm font-semibold text-gray-300 mb-2">Full Name *</label>
                    <input 
                      type="text" 
                      name="name" // Eklendi
                      required // Eklendi
                      placeholder="John Doe"
                      className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white placeholder-gray-500 focus:outline-none focus:border-brand-magenta focus:ring-1 focus:ring-brand-magenta transition-all"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-300 mb-2">Email Address *</label>
                    <input 
                      type="email" 
                      name="email" // Eklendi
                      required // Eklendi
                      placeholder="john@example.com"
                      className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white placeholder-gray-500 focus:outline-none focus:border-brand-magenta focus:ring-1 focus:ring-brand-magenta transition-all"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-300 mb-2">Your Industry *</label>
                    <input 
                      type="text" 
                      name="industry" // Eklendi
                      required // Eklendi
                      placeholder="e.g. E-commerce, SaaS, Coaching"
                      className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white placeholder-gray-500 focus:outline-none focus:border-brand-magenta focus:ring-1 focus:ring-brand-magenta transition-all"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-300 mb-2">Video URL *</label>
                    <input 
                      type="url" 
                      name="video_url" // Eklendi
                      required // Eklendi
                      placeholder="https://www.tiktok.com/..."
                      className="w-full bg-white/5 border border-white/10 rounded-xl px-5 py-4 text-white placeholder-gray-500 focus:outline-none focus:border-brand-magenta focus:ring-1 focus:ring-brand-magenta transition-all"
                    />
                    <p className="text-[10px] text-gray-500 mt-2 italic">Paste the link to the video you want us to analyze</p>
                  </div>

                  {/* Button type "submit" olduğundan emin olunmalı */}
                  <button 
                    type="submit" 
                    className="w-full bg-brand-magenta hover:bg-brand-magenta/90 text-white font-bold py-5 rounded-xl transition-all flex items-center justify-center gap-2 group shadow-lg shadow-brand-magenta/20 mt-4"
                  >
                    Get My Free Audit
                    <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} />
                  </button>

                  <div className="flex items-center justify-center gap-2 text-gray-500 text-xs mt-6">
                    <Lock size={14} />
                    <span>Your information is secure. We'll never share your details.</span>
                  </div>
                </form>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default FreeAuditSection;